import { User } from "./user.model";

export type ActivityTrace = {
  id: string
  name: string
  log: string[]
  status: "FAILED" | "COMPLETED" | "CREATED" | "RUNNING" | "WARNING"
  error_detail: string
}

/**
 * One error a publisher network returned, lifted back out of the job's own log lines
 * (MPN-1337). `summary` is the network's answer -- Meta's advertiser-facing text where
 * it supplies one; `context` is the sentence we logged around it, which names the object
 * but not the problem.
 */
/** Where in the app this error is fixed. `path` is app-relative. */
export type FixLink = {
  label: string
  path: string
}

export type NetworkError = {
  network: string
  code: string | null
  title: string | null
  summary: string
  context: string | null
  transient: boolean
  span_name: string | null
  fix: FixLink | null
}

type JobContext = {
  traces: ActivityTrace[]
  output: any
}

export class Job {
  id: number;
  name: string;
  progress_message: string;
  type: string;
  status: string;
  job_context: JobContext;
  input: any;
  percent_complete: number;
  create_date: string;
  update_date: string;
  children: Job[]
  user: User;
  // Which engagement / campaign / network this job is for (MPN-1636). Derived server
  // side from the job's own input; null for the many job types that belong to none of
  // them, and the page shows the job type in their place.
  //
  // Declared here because the serializer copies only the keys the constructor defines --
  // a field added to the API and not to this class is silently dropped, which is how
  // MPN-1624 shipped broken.
  engagement_id: number | null;
  engagement_name: string | null;
  campaign_id: number | null;
  campaign_name: string | null;
  network: string | null;
  /** The operation this job came from, when it came from one. */
  batch_id: number | null;

  constructor() {
    this.id = 0;
    this.name = "";
    this.progress_message = "";
    this.type = "";
    this.status = "";
    this.job_context = {traces: [], output: {}};
    this.input = {};
    this.percent_complete = 0;
    this.create_date = "";
    this.update_date = "";
    this.children = []
    this.user = new User();
    this.engagement_id = null;
    this.engagement_name = null;
    this.campaign_id = null;
    this.campaign_name = null;
    this.network = null;
    this.batch_id = null;
  }
}
